import { render, staticRenderFns } from "./EditSGConfig.vue?vue&type=template&id=049a2e34&scoped=true"
import script from "./EditSGConfig.vue?vue&type=script&lang=js"
export * from "./EditSGConfig.vue?vue&type=script&lang=js"
import style0 from "./EditSGConfig.vue?vue&type=style&index=0&id=049a2e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a2e34",
  null
  
)

export default component.exports